// Copyright (c) 2017 Deere & Company

import React, {PropTypes} from 'react';
import Debit from '@deere/cps-it.warranty-model-factory/lib/debit';
import DebitModalBody from './debit-modal-body';
import DebitModalHeader from './debit-modal-header';
import WarrantyLoadingIndicator from '../../../../shared/components/warranty-loading-indicator';
import {WarrantyMediumModal} from '../../../../shared/components/modal';

const DebitModal = props =>
    <section className='debit-modal'>
        <WarrantyMediumModal isOpen={props.isModalVisible}>
            <WarrantyLoadingIndicator isLoading={props.busyCounter > 0}/>
            <DebitModalHeader
                claimNumber={props.debit.claimNumber}
                closeModal={props.closeModal}
                debitType={props.debitType}
            />
            <DebitModalBody
                amountDebit={props.amountDebit}
                debit={props.debit}
                debitType={props.debitType}
                onCommentsChange={props.onCommentsChange}
                onConfirmation={props.onConfirmation}

            />
        </WarrantyMediumModal>
    </section>;

DebitModal.displayName = 'DebitModal';
DebitModal.propTypes = {
    amountDebit: PropTypes.number,
    busyCounter: PropTypes.number.isRequired,
    closeModal: PropTypes.func.isRequired,
    debit: PropTypes.instanceOf(Debit).isRequired,
    debitType: PropTypes.string.isRequired,
    isModalVisible: PropTypes.bool.isRequired,
    onCommentsChange: PropTypes.func.isRequired,
    onConfirmation: PropTypes.func.isRequired
};

export default DebitModal;



// WEBPACK FOOTER //
// ./src/tcsm/shared/components/debit-modal/index.js